import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { JagoAxiosInstance } from './JagoAxiosInstance';

export interface ICheckUpdatedAgreementsParams {
  serviceName?: string;
  [key: string]: any;
}

export interface ICheckUpdatedAgreementsResponse {
  updated: boolean;
  [key: string]: any;
}

export interface IAcceptAgreementsDTO {
  ids: any[];
  [key: string]: any;
}

export function fetchLatestAgreements(params?: any): Promise<AxiosResponse<any>> {
  const config: AxiosRequestConfig = {
    params,
  };
  return JagoAxiosInstance.get('api/v2/agreements/last', config);
}

export function checkUpdatedAgreements(params?: ICheckUpdatedAgreementsParams): Promise<AxiosResponse<ICheckUpdatedAgreementsResponse>> {
  const config: AxiosRequestConfig = {
    params,
  };
  return JagoAxiosInstance.get('api/v2/agreements/check', config);
}

export function acceptAgreements(data: IAcceptAgreementsDTO): Promise<AxiosResponse<any>> {
  return JagoAxiosInstance.post('api/v2/agreements', data);
}

